module.exports = __webpack_public_path__ + "static/media/nearby.14c009b9.png";